import { Pipe, PipeTransform, Injectable } from '@angular/core';

/**
 * Returns only first letter of string
 */
@Pipe({
  name: 'promoType'
})

@Injectable({
  providedIn: 'root'  // 👈 makes it injectable anywhere
})

export class PromoTypePipe implements PipeTransform {
  transform(code: any, promo_type: any, promo_sub_type: any): any {
    switch(code) {
      case 'PP_CHALLENGE_PHASE_1':
        if (+promo_type == 4 && +promo_sub_type == 3) {
          return true;
        }
        break;
      case 'PP_CHALLENGE_PHASE_2':
        if (+promo_type == 3 && +promo_sub_type == 5) {
          return true;
        }
        break;
      case 'BTG_CHALLENGE_PHASE_1':
        if (+promo_type == 3 && +promo_sub_type == 6) {
          return true;
        }
        break;
      case 'BTG_CHALLENGE_PHASE_2':
        if (+promo_type == 3 && +promo_sub_type == 7) {
          return true;
        }
        break;
    }

    return false;
  }
}